import React from 'react';

import clsx from 'clsx';

import type { BaseComponentProps } from '@coursera/cds-common';

import cardCss, { classes } from '@core/cards/Card/cardCss';

export type Props = {
  /**
   * Optional additional classes for the root element
   */
  className?: string;

  /**
   * Allows you to enable the hover styles.
   * @default false
   */
  interactive?: boolean;

  /**
   * Children to be rendered inside the card.
   */
  children?: React.ReactNode;
} & BaseComponentProps<'div'>;

/**
 * The Card is a basic utility component that shares the spacing, border, and hover
 * styles underlying the Product cards.
 *
 * See [Props](__storybookUrl__/utility-card--default#props) for usage info.
 */
const Card = React.forwardRef(function Card(
  props: Props,
  ref: React.Ref<HTMLDivElement>
) {
  const { className, children, interactive = false, ...rest } = props;
  return (
    <div
      ref={ref}
      className={clsx(
        classes.base,
        { [classes.shouldHover]: interactive },
        className
      )}
      css={cardCss}
      {...rest}
    >
      <div className={classes.innerCard}>{children}</div>
    </div>
  );
});

export default Card;
